import { BaseService } from './base.service';

export default class TeamStatsService extends BaseService {
  public async getBasicTeamStats(teamId: string, startDate: string, endDate: string) {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
    }).toString();

    return this.axios.get(`${this.backendUrl}/team/${teamId}/stats?${params}`);
  }

  public async getAttendanceTeamStats(teamId: string, startDate: string, endDate: string) {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
    }).toString();

    return this.axios.get(`${this.backendUrl}/team/${teamId}/attendance-stats?${params}`);
  }
}
